import React from 'react';

import DataContainer from 'Components/UI/DataContainer';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import Content from './Content';

const Container = () => {
  const { pageContentResource } = usePageContentContext();

  const [state, setState] = React.useState({
    collection: null,
    loadingError: null,
  });

  useComponentDidMount(async () => {
    try {
      const coll = await pageContentResource.relationship(fr.relationships.addEmptyItem.name).link('related').get();
      const updatedColl = coll.create({ addToCollection: true });
      setState({ loadingError: null, collection: updatedColl });
    } catch (err) {
      setState({ loadingError: err, collection: null });
    }
  });

  return (
    <DataContainer
      loading={!state.collection}
      component={Content}
      componentProps={{
        collection: state.collection,
      }}
    />
  );
};

Container.propTypes = {
};

export default Container;
